<template>
  <div>
    <vxe-modal ref="modal" v-model="formVisible" width="100%" height="100%" @show="showModal">
      <template #title>
        <span>合同管理{{ DocumentStatus }}</span>
        <span v-if="hasReUpload" style="color: red">[非使用模板文件]</span>
      </template>
      <div class="formContainer resize-box" ref="boxRef">
        <div class="leftFormContainer resize-left" ref="resizeLeftRef">
          <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="!isCreator || isSubmit">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="合同编号" prop="num">
                  <el-input placeholder="合同编号" v-model="form.num"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合同标题" prop="contract_title">
                  <el-input placeholder="合同标题" v-model="form.contract_title"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="hasQuotationApply">
                <el-form-item label="关联报价" prop="quotation_apply_title">
                  <el-input v-model="form.quotation_apply_title" clearable placeholder="请选择" readonly>
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="openQuotationApplySelect"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合同模板" prop="contract_template_name">
                  <el-input
                    v-model="form.contract_template_name"
                    :disabled="id > 0"
                    clearable
                    placeholder="请选择"
                    readonly
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="openTempSelect"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="项目名称" prop="project_name">
                  <el-input placeholder="项目名称" v-model="form.project_name"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="公司" prop="company">
                  <el-select placeholder="公司" v-model="form.company">
                    <el-option label="福州远控" value="福州远控"></el-option>
                    <el-option label="福建远控" value="福建远控"></el-option>
                    <el-option label="中心" value="中心"></el-option>
                    <el-option label="公司" value="公司"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="甲方单位" prop="client">
                  <el-input placeholder="甲方单位" v-model="form.client"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否邮寄" prop="is_mailed">
                  <el-select placeholder="是否邮寄" v-model="form.is_mailed" @change="mailedChange">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="签订日期" prop="signing_date">
                  <el-date-picker
                    v-model="form.signing_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择签订日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合同到期日" prop="validity_date">
                  <el-date-picker
                    v-model="form.validity_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择合同到期日"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="合同金额" prop="contract_amount">
                  <el-input placeholder="合同金额" v-model="form.contract_amount">
                    <template slot="append">{{ amountInCapitalLetters }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="是否已提交" prop="isSubmit">-->
              <!--                  <el-input disabled v-model="form.isSubmit"> </el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="已确认人" prop="confirmor">-->
              <!--                  <el-input placeholder="已确认人" disabled v-model="form.confirmor"> </el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
            </el-row>
          </el-form>
          <div class="table-panel">
            <el-tabs v-model="activeTableName" type="border-card">
              <el-tab-pane name="variable" label="数据">
                <div class="flex-center">
                  <el-button
                    type="text"
                    :disabled="!isCreator || isSubmit"
                    @click="addVariable"
                    circle
                    icon="el-icon-plus"
                  ></el-button>
                  <el-button
                    :disabled="!isCreator || isSubmit"
                    type="text"
                    @click="delVariable"
                    circle
                    icon="el-icon-delete"
                    style="color: red"
                  ></el-button>
                </div>
                <div class="table-container">
                  <vxe-grid
                    ref="xTable"
                    resizable
                    :column-config="{ minWidth: '80px' }"
                    :data="tableData"
                    :showOverflow="true"
                    size="mini"
                    :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: true }"
                    :mouse-config="{ area: true }"
                    :tooltip-config="{
                      showAll: true,
                      theme: 'dark'
                    }"
                    highlight-hover-row
                    highlight-current-row
                    height="auto"
                    :columns="gridColumns"
                    :keyboard-config="{
                      isArrow: true,
                      isEnter: true,
                      isTab: true,
                      isClip: true,
                      enterToTab: true,
                      isEdit: true
                    }"
                    :scroll-y="{
                      mode: 'wheel'
                    }"
                    :edit-rules="variableRules"
                  >
                  </vxe-grid>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="form.is_mailed === '是'" name="mailDetail" label="邮寄">
                <div class="flex-center">
                  <el-button
                    type="text"
                    :disabled="!isCreator || isSubmit"
                    @click="addPostDetail"
                    circle
                    icon="el-icon-plus"
                  ></el-button>
                  <el-button
                    type="text"
                    :disabled="!isCreator || isSubmit"
                    @click="delMail"
                    circle
                    icon="el-icon-delete"
                    style="color: red"
                  ></el-button>
                </div>
                <div class="table-container">
                  <vxe-grid
                    ref="mailXTable"
                    resizable
                    :column-config="{ minWidth: '80px' }"
                    :data="form.mailList"
                    :showOverflow="true"
                    size="mini"
                    :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: false }"
                    :mouse-config="{ area: true }"
                    :tooltip-config="{
                      showAll: true,
                      theme: 'dark'
                    }"
                    highlight-hover-row
                    highlight-current-row
                    height="auto"
                    :columns="mailGridColumns"
                    :keyboard-config="{
                      isArrow: true,
                      isEnter: true,
                      isTab: true,
                      isClip: true,
                      enterToTab: true,
                      isEdit: true
                    }"
                    :scroll-y="{
                      mode: 'wheel'
                    }"
                    :edit-rules="mailRules"
                    @cell-menu="cellContextMenuEvent"
                    :menu-config="{ body: { options: bodyMenus }, visibleMethod: visibleMethod }"
                    @menu-click="contextMenuClickEvent"
                  >
                  </vxe-grid>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="resize-vertical-bar" ref="rvbRef"></div>
        <div class="rightFormContainer resize-right" ref="resizeRightRef">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="附件日志" name="first">
              <div class="attachments">
                <div class="file-container">
                  <FileList :ID="id" :isDisabled="!isCreator" ref="FileListRef" vuePath="ContractManagement" />
                </div>
                <div class="timeline">
                  <YKDivider>
                    <div>日志</div>
                  </YKDivider>
                  <div class="timeline-panel">
                    <el-timeline :reverse="true">
                      <el-timeline-item
                        v-for="(item, index) in form.timeLine"
                        :key="index"
                        :timestamp="item.logTime"
                        color="#6eb6ff"
                      >
                        {{ `${item.operator}: ${item.logContent}` }}
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="差异对比" name="second">
              <!--              <div class="content-title">-->
              <!--                {{ differenceNumber === 0 ? '无差异' : differenceNumber + '个差异' }}-->
              <!--              </div>-->
              <div class="difference-panel" ref="differenceDom">
                <div class="difference-content" v-html="differenceHtml"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!-- 页脚按钮 -->
      <div class="operate-area">
        <div class="approval-container">
          <strong>当前审批状态:</strong>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) of approverList" :key="index">{{ item }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="btn-container">
          <el-button type="primary" v-show="isCreator" @click="save" :disabled="isSubmit">保存</el-button>
          <el-button type="danger" v-show="id > 0 && isCreator" @click="del" :disabled="isSubmit">删除</el-button>
          <el-button type="warning" v-show="id > 0 && isCreator" @click="submit" :disabled="isSubmit">提交</el-button>
          <el-button
            type="warning"
            v-show="id > 0 && isCreator && form.document_status === 1"
            @click="cancelSubmit(false, '')"
            >撤销提交</el-button
          >
          <el-button
            type="primary"
            v-show="this.form.contract_templates_id > 0 && isCreator && this.id > 0"
            @click="editContract"
            :disabled="isSubmit"
            >重新上传合同</el-button
          >
          <el-button v-show="form.paymentList.length > 0" @click="openPayDetail"> 查看分批付款明细 </el-button>
          <el-button
            type="success"
            v-if="getApproveBtnVisible(form, vuePath, 'accept')"
            style="min-width: 140px"
            @click="handleClick('accept')"
            >通过</el-button
          >

          <el-button
            type="danger"
            v-if="getApproveBtnVisible(form, vuePath, 'refuse')"
            style="min-width: 140px"
            @click="handleClick('refuse')"
            >不通过</el-button
          >

          <el-button
            type="danger"
            v-if="getApproveBtnVisible(form, vuePath, 'revoke')"
            style="min-width: 140px"
            @click="handleClick('revoke')"
            >撤销</el-button
          >
          <el-button type="primary" v-show="id > 0" @click="exportWord">导出Word</el-button>
          <el-button @click="() => (formVisible = false)">关闭</el-button>
        </div>
      </div>
    </vxe-modal>
    <ContractTempSelect ref="TempSelect" @sure="handleTempSelect" />
    <el-dialog title="批注" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-input v-model="commentContent" placeholder="请输入批注内容" type="textarea" :rows="2" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleComment">确 定</el-button>
      </span>
    </el-dialog>
    <input
      type="file"
      ref="uploadRef"
      v-show="false"
      id="open"
      multiple="multiple"
      @change="uploadFile"
      accept=".docx"
    />
    <!-- 领导审核 -->
    <FastInputVue ref="FastInputVueRef" @sureBack="sureBackApprovalOpinions" />
    <FastInputVue ref="FastInputVueRefuseRef" @sureBack="sureBackRefuseOpinions" />
    <!-- 日期输入框 -->
    <DateInput ref="DateInputRef" @sureHandler="sureBackDate" />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" @sureBackPerson="sureBackPerson" :isMultiple="false" />

    <!-- 滚动条自定义右键 -->
    <MyContextMenu ref="MyContextMenuRef" @backContextMenu="contextMenuClickEvent" />

    <QuotationApplySelect ref="QuotationApplySelectRef" @sure="handleQuotationApplySelect" />

    <BatchPayDetailModal ref="BatchPayDetailModal"></BatchPayDetailModal>
  </div>
</template>

<script>
import FileList from '@/components/Form/FileList.vue'
import ContractTempSelect from '@/views/ContractManagement/ContractTempSelect.vue'
import QuotationApplySelect from '@/views/ContractManagement/QuotationApplySelect.vue'
import fileSaver from 'file-saver'
import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import mammoth from 'mammoth'
import HtmlDiff from 'htmldiff-js/src/Diff'
import FastInputVue from '@/components/Modal/FastInput/FastInput.vue'
import MyContextMenu from '@/components/common/MyContextMenu.vue'
import { getApproveBtnVisible, getApprover, getState } from '@/utils/state'
import BatchPayDetailModal from '@/views/ContractManagement/BatchPayDetailModal.vue'

const baseUrl = {}
export default {
  name: 'DetailModal',
  components: { MyContextMenu, FastInputVue, ContractTempSelect, FileList, QuotationApplySelect, BatchPayDetailModal },
  data() {
    return {
      id: -1,
      formVisible: false,
      tableData: [],
      gridColumns: [
        { type: 'seq', width: 40, fixed: 'left' },
        { type: 'checkbox', width: 40, fixed: 'left' },
        {
          field: 'variable_name',
          title: '变量名称',
          editRender: { name: 'input' }
        },
        {
          field: 'variable_value',
          title: '变量值',
          editRender: { name: 'input' }
        }
      ],
      mailGridColumns: [
        { type: 'seq', width: 40, fixed: 'left' },
        { type: 'checkbox', width: 40, fixed: 'left' },
        {
          field: 'sender',
          title: '寄件人',
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'ship_date',
          title: '寄件日期',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'contribution_details',
          title: '寄件内容',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        },
        {
          field: 'courier_company',
          title: '快递公司',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'is_expedited',
          title: '是否加急',
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'receiving_company',
          title: '收件单位',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'recipient',
          title: '收件人',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'express_number',
          title: '快递单号',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        }
      ],
      // 表单
      form: {
        quotation_apply_id: 0,
        quotation_apply_title: '',
        detailList: [],
        paymentList: [],
        mailList: [],
        timeLine: [],
        id: 0,
        num: '',
        contract_title: '',
        confirmor: '',
        contract_templates_id: 0,
        contract_template_name: '',
        project_name: '',
        last_modify_time: '',
        content: '',
        creator_id: 0,
        creator: '',
        createTime: '',
        company: '福州远控',
        client: '',
        is_mailed: '否',
        contract_amount: 0,
        signing_date: '',
        validity_date: '',
        manager_review: true,
        document_status: 0
      },
      rules: {
        contract_template_name: [
          { required: true, message: '请选择合同模板', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        contract_title: [
          { required: true, message: '请输入合同标题', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        project_name: [
          { required: true, message: '请输入项目名称', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        num: [
          { required: true, message: '请输入合同编号', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        company: [{ required: true, message: '请选择公司', trigger: 'change' }],
        client: [{ required: true, message: '请输入甲方单位信息', trigger: 'change' }],
        is_mailed: [{ required: true, message: '请选择是否邮寄', trigger: 'change' }],
        contract_amount: [
          { required: true, message: '请输入合同金额', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 15,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        signing_date: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        validity_date: [{ required: true, message: '请选择合同到期日', trigger: 'change' }]
      },
      variableRules: {
        variable_name: [
          { required: true, message: '请输入变量值', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        variable_value: [
          { required: true, message: '请输入变量值', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ]
      },
      mailRules: {
        sender: [
          { required: true, message: '请选择寄件人', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        ship_date: [{ required: true, message: '请输入寄件日期', trigger: 'change' }],
        contribution_details: [
          { required: true, message: '请输入寄件内容', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        courier_company: [
          { required: true, message: '请输入快递公司', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        is_expedited: [],
        recipient: [
          { required: true, message: '请输入收件人', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        receiving_company: [
          { required: true, message: '请输入收件单位', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ]
      },
      isChange: false,
      dataBindingComplete: false,
      dialogVisible: false,
      commentContent: '',
      editDisabled: false,
      vuePath: 'ContractManagement',
      hasReUpload: false,
      needUpload: false,
      delDetail: [],
      delMailDetail: [],
      // 原模板文件
      cacheOrgFile: '',
      cacheFile: '',
      // 原模板的路径
      orgTempPath: '',
      newTempPath: '',
      orgHtml: '',
      newHtml: '',
      activeName: 'first',
      activeTableName: 'variable',
      // 右键缓存
      areas: {},
      colProperty: '',
      bodyMenus: [],
      combobox: {
        client: []
      }
    }
  },
  mounted() {},
  methods: {
    getApproveBtnVisible,
    handleResize() {
      const boxDom = this.$refs.boxRef
      const leftDom = this.$refs.resizeLeftRef
      const resizeDom = this.$refs.rvbRef
      const rightDom = this.$refs.resizeRightRef
      resizeDom.onmousedown = e => {
        const startX = e.clientX
        leftDom.left = leftDom.offsetWidth
        document.onmousemove = e => {
          const endX = e.clientX
          let moveLen = leftDom.left + (endX - startX)
          const maxWidth = boxDom.clientWidth - resizeDom.offsetWidth
          const minWidth = maxWidth * 0.2
          if (moveLen < minWidth) {
            moveLen = minWidth
          }
          if (moveLen > maxWidth - minWidth) {
            moveLen = maxWidth - minWidth
          }
          leftDom.style.width = (moveLen / maxWidth) * 100 + '%'
          rightDom.style.width = ((maxWidth - moveLen) / maxWidth) * 100 + '%'
        }
        document.onmouseup = () => {
          document.onmousemove = null
          document.onmouseup = null
          resizeDom.releaseCapture && resizeDom.releaseCapture()
        }
        resizeDom.setCapture && resizeDom.setCapture()
        return false
      }
    },
    // 是否邮寄变化时
    mailedChange(str) {
      this.$nextTick(() => {
        if (str === '是') {
          this.activeTableName = 'mailDetail'
          if (this.form.mailList.length <= 0) {
            this.form.mailList.push({
              id: 0,
              sender: this.$store.state.userInfo.name,
              ship_date: this.ykDateFormat('yyyy-MM-dd', new Date()),
              is_expedited: '否',
              receiving_company: this.form.client,
              courier_company: '',
              express_number: ''
            })
          }
        }
      })
    },
    async submit() {
      const { data: res } = await this.$http.put(`/Finance/Contract/submit-audit`, [{ id: this.id }])
      if (res.isSuccess) {
        this.BindText()
        this.$message.success('提交成功')
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    uploadFile(event) {
      let files = event.target.files
      if (files.length === 0) return
      const isDocxFile = files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      if (!isDocxFile) {
        this.$message.warning('请上传.docx文件')
        this.$refs.uploadRef.value = ''
        return
      }
      this.parsingTemplate(files[0])
      this.hasReUpload = true
      this.needUpload = true
      this.cacheFile = files[0]
      // this.handleUploadWordTemp(files[0])
      this.$refs.uploadRef.value = ''
    },
    async handleUploadWordTemp(file, writeToDB = true) {
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      const guID = this.genreactUUID()
      let formData = new FormData()
      formData.append('file', file)
      formData.append('vuePathName', this.vuePath + '/temp')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      const { data: res } = await this.$http.post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
      if (res.isSuccess) {
        if (writeToDB) {
          await this.writeToDB(res.data)
        } else {
          return res.data
        }
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async writeToDB(file) {
      let uploadTime = new Date().getTime() + ''
      const temp = {
        aKeyValue: this.id,
        aName: file.aName,
        aDisplay: file.aDisplay,
        aClass: file.aClass,
        aPath: file.aPath,
        aType: file.aType,
        aSize: file.aSize,
        aLength: file.aLength,
        sort: uploadTime
      }
      const { data: res } = await this.$http.post(`/base/attachment/bulk-insert`, [temp])
      if (res.isSuccess) {
        await this.getFileListByApi()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async getFileListByApi() {
      const { data: res } = await this.$http.post('/base/attachment', {
        vuePath: this.vuePath + '/temp',
        keyValue: this.id
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      } else {
        if (res.data.length > 0) {
          if (res.data.length > 1) {
            const { data: del } = await this.$http.delete(`/base/attachment/${res.data[0].id}`)
            if (!del.isSuccess) {
              this.$message.error(del.errorMessage)
              return false
            }
          }
          const currentTemp = res.data[res.data.length - 1]
          this.newTempPath = currentTemp.filePath
        }
      }
    },
    async parsingTemplate(file) {
      if (!file) return
      this.tableData.forEach(item => {
        if (item.id > 0) {
          item.id = 0 - item.id
          this.delDetail.push(item)
        }
      })
      this.tableData = []
      const reader = new FileReader()
      reader.onload = async e => {
        const arrayBuffer = e.target.result
        try {
          const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          this.currentHtml = result.value
          // 解析文档中的变量
          const variableRegex = /\{([^{}]+)\}/g
          const variables = []
          let match
          while ((match = variableRegex.exec(result.value)) !== null) {
            const variableName = match[1].trim()
            if (!variables.includes(variableName)) {
              variables.push(variableName)
            }
          }
          // 如果找到变量，添加到表格中
          if (variables.length > 0) {
            variables.forEach(variable => {
              this.tableData.push({
                id: 0,
                variable_name: variable,
                variable_value: variable
              })
            })
          }
        } catch (error) {
          console.error('解析文档时出错:', error)
          this.$message.error('解析文档失败')
        }
      }

      reader.onerror = () => {
        this.$message.error('读取文件失败')
      }

      reader.readAsArrayBuffer(file)
    },
    openPayDetail() {
      this.$refs.BatchPayDetailModal.openModal(this.form.id)
    },
    async handleDownloadFile(path) {
      return new Promise((resolve, reject) => {
        let upload = baseUrl.upload
        if (!upload) {
          upload = window.location.origin
        }
        this.$http
          .get(`/base/attachment/secret`, {
            params: {
              urlstr: `${upload}/download/${path}`
            }
          })
          .then(res => {
            const url = res.data
            fetch(url)
              .then(res => res.blob())
              .then(blob => {
                resolve(blob)
              })
          })
      })
    },
    async handleComment() {
      if (this.commentContent === '') return
      const { data: res } = await this.$http.post(`/Finance/Contract/comment`, {
        id: this.id,
        comment: this.commentContent
      })
      if (res.isSuccess) {
        this.$emit('updateData')
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async exportWord() {
      try {
        if (this.isChange) {
          this.$message.warning('存在修改, 请先保存')
          return
        }
        let docxHandler = ''
        const file = this.hasReUpload ? this.cacheFile : this.cacheOrgFile
        const reader = new FileReader()
        const options = {
          modules: []
        }
        reader.onload = e => {
          const arrayBuffer = e.target.result
          docxHandler = new Docxtemplater(new PizZip(arrayBuffer), options)
          const params = this.tableData.reduce((acc, item) => {
            acc[item.variable_name] = item.variable_value
            return acc
          }, {})
          docxHandler.render(params)
          const blob = docxHandler.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          })
          fileSaver.saveAs(blob, `${this.form.contract_title}.docx`)
        }
        reader.readAsArrayBuffer(file)

        const { data: res } = await this.$http.put(`/Finance/Contract/print/${this.id}`)
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
        }
      } catch (e) {
        this.$message.error('导出失败，文件错误')
      }
    },
    editContract() {
      if (this.id === 0) {
        this.$message.warning('请先保存')
        return
      }
      this.$refs.uploadRef.click()
    },
    async handleTempSelect(record) {
      await this.BindTempHtml(record.id)
    },
    handleQuotationApplySelect(record) {
      this.form.quotation_apply_id = record.id
      this.form.quotation_apply_title = '已关联'
      if (this.form.client === '') {
        this.form.client = record.customer_name
      }
      if (this.form.project_name === '') {
        this.form.project_name = record.project_name
      }
      if (this.form.contract_amount === 0) {
        this.form.contract_amount = record.final_quotation
      }
    },
    openTempSelect() {
      if (this.id > 0) return
      this.$refs.TempSelect.openModal()
    },
    openQuotationApplySelect() {
      this.$refs.QuotationApplySelectRef.openModal()
    },
    async BindTempHtml(id) {
      const { data: res } = await this.$http.get('/Finance/Contract/Template', {
        params: {
          id
        }
      })
      if (res.isSuccess) {
        this.form.contract_template_name = res.data.contract_template_name
        this.form.contract_templates_id = res.data.id
        this.form.content = res.data.content
        try {
          this.tableData = JSON.parse(this.form.content).detail
        } catch (e) {
          console.log(e)
          this.$message.error('模板解析失败')
        }
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    querySearchClient(queryString, cb) {
      const results = queryString
        ? this.combobox.client.filter(item => String(item.value).includes(queryString))
        : this.combobox.client
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    async BindComBox() {
      this.combobox.client = []
      this.bodyMenus = [
        [
          {
            code: 'yesOrNo',
            name: '是'
          },
          {
            code: 'yesOrNo',
            name: '否'
          },
          {
            code: 'courier_company',
            name: '京东物流'
          },
          {
            code: 'courier_company',
            name: '顺丰速运'
          },
          {
            code: 'courier_company',
            name: '邮政快递'
          },
          {
            code: 'courier_company',
            name: '韵达快递'
          },
          {
            code: 'courier_company',
            name: '中通快递'
          },
          {
            code: 'courier_company',
            name: '圆通速递'
          },
          {
            code: 'courier_company',
            name: '申通快递'
          },
          {
            code: 'courier_company',
            name: '百世快递'
          }
        ]
      ]

      const { data: selectRes } = await this.$http.get('/Finance/Report_approve/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'client':
              this.combobox.client.push({
                label: item.name,
                value: item.value
              })
              break
            // 收件单位
            case 'receiving_company':
              this.bodyMenus[0].push({
                code: 'receiving_company',
                name: item.name
              })
              break
            default:
              if (item.comments === '收件人') {
                this.bodyMenus[0].push({
                  code: `recipient#@#${item.code}`,
                  name: item.name
                })
              }
              break
          }
        }
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column, row }, event) {
      this.areas = this.$refs.mailXTable.getCellAreas()
      this.colProperty = column.property

      if (!this.isDisabled && ['ship_date'].includes(column.property)) {
        this.$refs.DateInputRef.formVisible = true
      }

      if (!this.isDisabled && ['sender'].includes(column.property)) {
        this.$refs.EmployeeSelectRef.formVisible = true
      }

      // 收件单位 和 收件人用自定义右键
      if (column.property === 'receiving_company' || column.property === 'recipient') {
        let eve = event || window.event
        const x = eve.clientX
        const y = eve.clientY
        let filter_receiving_company_str = row.receiving_company
        let filter_recipient_str = row.recipient
        if (column.property === 'receiving_company') {
          this.$refs.MyContextMenuRef.options = this.bodyMenus[0].filter(item => {
            if (row.receiving_company) {
              return item.code === 'receiving_company' && item.name.includes(filter_receiving_company_str)
            } else {
              return item.code === 'receiving_company'
            }
          })
        } else {
          this.$refs.MyContextMenuRef.options = this.bodyMenus[0].filter(item => {
            let visible = false

            if (row.receiving_company) {
              if (item.code.includes('recipient#@#')) {
                if (row.recipient) {
                  visible =
                    item.code.split('#@#')[1] === row.receiving_company && item.name.includes(filter_recipient_str)
                } else {
                  visible = item.code.split('#@#')[1] === row.receiving_company
                }
              }
            } else {
              if (row.recipient) {
                visible = item.code.includes('recipient#@#') && item.name.includes(filter_recipient_str)
              } else {
                visible = item.code.includes('recipient#@#')
              }
            }
            return visible
          })
        }
        this.$refs.MyContextMenuRef.mouseX = x
        this.$refs.MyContextMenuRef.mouseY = y
        this.$refs.MyContextMenuRef.disabled = this.isDisabled
        this.$refs.MyContextMenuRef.formVisible = true
        setTimeout(() => {
          this.$refs.MyContextMenuRef.setposition()
        }, 25)
      }
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = this.isDisabled
          if (column) {
            switch (column.property) {
              case 'is_expedited':
                item.visible = item.code === 'yesOrNo'
                break
              case 'courier_company':
                item.visible = item.code === 'courier_company'
                break
              // case 'receiving_company':
              //   item.visible = item.code === 'receiving_company'
              //   break
              // case 'recipient':
              //   // 如果有收件单位的字段, 根据它过滤
              //   if (row.receiving_company) {
              //     let visible = false
              //     if (item.code.includes('recipient#@#')) {
              //       visible = item.code.split('#@#')[1] === row.receiving_company
              //     }
              //     item.visible = visible
              //   } else {
              //     item.visible = item.code.includes('recipient#@#')
              //   }
              //   break
              default:
                item.visible = false
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              if (col.property === 'is_expedited') {
                if (menu.name === '清空') {
                  row['is_expedited'] = ''
                } else {
                  row['is_expedited'] = menu.name
                }
              } else if (col.property === 'courier_company') {
                if (menu.name === '清空') {
                  row['courier_company'] = ''
                } else {
                  row['courier_company'] = menu.name
                }
              } else if (col.property === 'receiving_company') {
                row['receiving_company'] = menu.name
                const filterItems = this.bodyMenus[0].filter(item => item.code === `recipient#@#${menu.name}`)
                // 如果没有收件人, 直接赋值
                row['recipient'] = ''
                if (filterItems.length === 1) {
                  row['recipient'] = filterItems[0].name
                }
              } else if (col.property === 'recipient') {
                const receiving_company = menu.code.split('#@#')[1]
                if (row['receiving_company'] === receiving_company) {
                  // 有的话按照收件单位赋值
                  row['recipient'] = menu.name
                } else if (!row['receiving_company']) {
                  // 没有的话直接赋值
                  row['receiving_company'] = receiving_company
                  row['recipient'] = menu.name
                }
              }
            }
          }
        }
      })

      this.$refs.xTable.updateData()
    },
    // 日期返回
    sureBackDate(date) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = date
            }
          }
        }
      })
    },
    // 选择完成后
    sureBackPerson(person) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = person
            }
          }
        }
      })
    },
    // 输入完意见
    async sureBackApprovalOpinions(options) {
      const flag = await this.sureReview(false, options)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()
        this.$refs.FastInputVueRef.closeModal()
      }
    },
    async sureBackRefuseOpinions(options) {
      const flag = await this.sureUnReview(false, options)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()

        this.$refs.FastInputVueRefuseRef.closeModal()
      }
    },
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = true
        },
        err => {
          flag = false
        }
      )
      if (this.form.is_mailed === '是') {
        if (this.form.mailList.length === 0) {
          this.$message.warning('选择邮寄时, 邮寄明细不能为空')
          return false
        }
      }
      this.removeEmptyForTable(this.$refs.xTable)
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        this.$message.error('验证失败,请核对输入数据')
        this.activeTableName = 'variable'
        return false
      }
      if (this.form.is_mailed === '是') {
        this.removeEmptyForTable(this.$refs.mailXTable)
        const mailErrMap = await this.$refs.mailXTable.fullValidate(true).catch(errMap => errMap)
        if (mailErrMap) {
          this.$message.error('验证失败,请核对输入数据')
          this.activeTableName = 'mailDetail'
          return false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    async save() {
      const flag = await this.validEnter()
      if (flag) {
        if (this.tableData.length === 0) {
          this.$confirm('没有变量, 是否继续保存?', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          })
            .then(async () => {
              if (this.id && this.id > 0) {
                this.update()
              } else {
                this.add()
              }
            })
            .catch(() => {})
        } else {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      }
    },
    addVariable() {
      const params = {
        id: 0,
        variable_name: '',
        variable_value: ''
      }
      this.tableData.push(params)
    },
    addPostDetail() {
      const params = {
        id: 0,
        sender: this.$store.state.userInfo.name,
        ship_date: this.ykDateFormat('yyyy-MM-dd', new Date()),
        is_expedited: '否',
        receiving_company: this.form.client,
        courier_company: '',
        express_number: ''
      }
      this.form.mailList.push(params)
    },
    delVariable() {
      const checkRecords = this.$refs.xTable.getCheckboxRecords()
      if (checkRecords.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delXIDList = checkRecords.map(item => item._XID)
        checkRecords.forEach(item => {
          if (item.id > 0) {
            item.id = 0 - item.id
            this.delDetail.push(item)
          }
        })
        this.tableData = this.tableData.filter(item => !delXIDList.includes(item._XID))
      })
    },
    delMail() {
      const checkRecords = this.$refs.mailXTable.getCheckboxRecords()
      if (checkRecords.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delXIDList = checkRecords.map(item => item._XID)
        checkRecords.forEach(item => {
          if (item.id > 0) {
            item.id = 0 - item.id
            this.delMailDetail.push(item)
          }
        })
        this.form.mailList = this.form.mailList.filter(item => !delXIDList.includes(item._XID))
      })
    },
    // 新增
    async add() {
      this.form.detailList = this.tableData
      const params = { ...this.form }
      const { data: res } = await this.$http.post('/Finance/Contract', params)
      if (res.isSuccess) {
        this.id = res.data
        this.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        this.BindText()
        this.$message.success(this.messageConfig.save.success)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      // 重新上传了模板
      const params = { ...this.form }
      params.content = JSON.stringify(params.content)
      params.detailList = [...this.tableData, ...this.delDetail]
      params.mailList = [...this.form.mailList, ...this.delMailDetail]
      const { data: res } = await this.$http.put('/Finance/Contract', params)
      if (res.isSuccess) {
        this.$emit('updateData')
        if (this.needUpload) {
          await this.handleUploadWordTemp(this.cacheFile)
        }
        this.BindText()
        this.$message.success(this.messageConfig.save.success)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$http.delete('/Finance/Contract', {
          data: {
            id: this.id
          }
        })
        if (res.isSuccess) {
          this.$message.success(this.messageConfig.del.success)
          this.formVisible = false

          this.$emit('updateData')
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    // 获取数据
    async BindText() {
      this.dataBindingComplete = false
      this.isChange = false
      this.commentContent = ''
      this.delDetail = []
      this.newTempPath = ''
      this.orgTempPath = ''
      this.cacheFile = ''
      this.cacheOrgFile = ''
      this.newHtml = ''
      this.orgHtml = ''
      this.hasReUpload = false
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Finance/Contract', {
          params: {
            id: this.id
          }
        })
        if (res.isSuccess) {
          res.data.signing_date = this.ykDateFormat('yyyy-MM-dd', res.data.signing_date)
          res.data.validity_date = this.ykDateFormat('yyyy-MM-dd', res.data.validity_date)
          if (res.data.quotation_apply_id > 0) {
            res.data.quotation_apply_title = '已关联'
          }
          this.form = res.data
          this.tableData = this.form.detailList
          this.form.content = JSON.parse(this.form.content)
          this.orgTempPath = this.form.content.path
          this.needUpload = false
          // 新上传的文件
          await this.getFileListByApi()
          this.cacheOrgFile = await this.handleDownloadFile(this.orgTempPath)
          if (this.newTempPath) {
            this.hasReUpload = true
            this.cacheFile = await this.handleDownloadFile(this.newTempPath)
          }
          this.getTempHtml()
        } else {
          this.$message.error(res.errorMessage)
        }
      } else {
        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
        this.form.content = ''
        this.form.project_name = ''
        this.form.contract_title = ''
        this.form.num = ''
        this.form.confirmor = ''
        this.form.contract_templates_id = 0
        this.form.contract_template_name = ''
        this.form.id = 0
        this.tableData = []
        this.form.timeLine = []
        this.id = 0
        this.form.last_modify_time = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
        this.form.signing_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        this.form.validity_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        this.form.mailList = []
        this.form.paymentList = []
        this.form.client = ''
        this.form.is_mailed = '否'
        this.form.company = '福州远控'
        this.form.contract_amount = 0
        this.form.document_status = 0
        this.form.quotation_apply_id = 0
        this.form.quotation_apply_title = ''
      }
      this.$nextTick(() => {
        this.dataBindingComplete = true
      })
    },
    async getTempHtml() {
      try {
        const result = await mammoth.convertToHtml({ arrayBuffer: this.cacheOrgFile })
        this.orgHtml = result.value
        if (this.hasReUpload) {
          const result = await mammoth.convertToHtml({ arrayBuffer: this.cacheFile })
          this.newHtml = result.value
        } else {
          this.newHtml = this.orgHtml
        }
      } catch (error) {
        console.error('解析文档时出错:', error)
        this.$message.error('解析文档失败')
      }
    },
    openModal(id = 0, activeTabName = 'variable') {
      this.id = id
      this.activeTableName = activeTabName
      this.$nextTick(() => {
        this.BindComBox()
        this.formVisible = true
      })
    },
    // cell激活控制
    activeMethod({ column }) {
      if (!this.isCreator || this.isSubmit) {
        return false
      }
      return !(column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true)
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    showModal() {
      this.BindText()
      this.getFileList()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.handleResize()
      })
    },
    // 调用审批接口
    async sureReview(flag = false, approve_opinions) {
      const approve_obj = typeof approve_opinions === 'string' ? { approve_opinions } : approve_opinions

      const { data: res } = await this.$http.put('/Finance/Contract/audit', [
        {
          id: this.id,
          manager_review: this.form.manager_review,
          ...approve_obj
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      await this.getFileList() // 重新拉附件

      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false, approve_opinions) {
      const approve_obj = typeof approve_opinions === 'string' ? { approve_opinions } : approve_opinions
      const { data: res } = await this.$http.put('/Finance/Contract/unaudit', [
        {
          id: this.id,
          manager_review: this.form.manager_review,
          ...approve_obj
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      await this.getFileList() // 重新拉附件

      return true
    },
    async cancelSubmit(flag = false, approve_opinions) {
      const approve_obj = typeof approve_opinions === 'string' ? { approve_opinions } : approve_opinions
      const { data: res } = await this.$http.put('/Finance/Contract/cancel-submit-audit', [
        {
          id: this.id,
          manager_review: this.form.manager_review,
          ...approve_obj
        }
      ])
      if (res.isSuccess) {
        this.$message.success('撤销成功')
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    handleClick(code) {
      if (code === 'accept') {
        // 根据情况返回不同的code
        const emitCode = this.getApproveBtnVisible(this.form, this.vuePath, 'accept')

        if (emitCode === 'manager') {
          this.$refs.FastInputVueRef.openModal()
        } else if (emitCode === 'leader') {
          this.$refs.FastInputVueRef.openModal()
        }
      } else if (code === 'refuse') {
        this.$refs.FastInputVueRefuseRef.openModal()
      } else if (code === 'revoke') {
        this.unReview()
      }
    }
  },
  watch: {
    tableData: {
      handler(val) {
        if (this.dataBindingComplete) {
          this.isChange = true
        }
      },
      deep: true
    }
  },
  computed: {
    isCreator() {
      return this.$store.state.userInfo.userId === this.form.creator_id
    },
    hasQuotationApply() {
      const menuList = this.$store.state.menulist
      return menuList.some(item => item.name === '报价')
    },
    isSubmit() {
      return this.form.document_status !== 0
    },
    differenceHtml() {
      return HtmlDiff.execute(this.orgHtml, this.newHtml)
    },
    // 获取审批人列表
    approverList() {
      return getApprover(this.form, this.vuePath).split(', ').reverse()
    },
    isDisabled() {
      return this.isSubmit || !this.isCreator
    },
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form, 'ContractManagement')}] `
    },
    amountInCapitalLetters() {
      const amount = this.form.contract_amount
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    }
  }
}
</script>

<style scoped lang="less">
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
  overflow: auto;
  .table-panel {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    /deep/.el-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      .el-tabs__item {
        font-size: 14px;
      }
      .el-tabs__content {
        flex-grow: 1;
      }
      .el-tab-pane {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }
    .table-container {
      flex-grow: 1;
    }
  }

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}

.rightFormContainer {
  height: 100%;
  box-sizing: border-box;
  padding: 0 10px;
}
.operate-area {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .approval-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .btn-container {
    display: flex;
    align-items: center;
  }
}
.file-container {
  height: 50%;
}
.timeline {
  height: 50%;
  display: flex;
  flex-direction: column;
  .timeline-panel {
    flex-grow: 1;
    padding: 15px 0;
    border-radius: 10px;
    overflow: auto;
    background-color: #eee;
  }
}
/deep/.el-timeline {
  padding-inline-start: 18px !important;
}
.difference-panel {
  overflow-x: hidden;
  overflow-y: auto;
  width: 99%;
  height: calc(100vh - 188px);
  border: 1px solid #ccc;
  .difference-content {
    padding: 0 10px;
  }
}
.attachments {
  width: 350px;
  height: calc(100vh - 188px);
}
/deep/.w-e-tag {
  margin: 0px 3px;
  font-size: 14px;
  background-color: rgb(236, 245, 255);
  color: rgb(64, 158, 255);
  border: 1px solid rgb(217, 236, 255);
  border-radius: 3px;
  padding: 3px 8px;
}
/deep/del.diffdel {
  color: red;
  text-decoration: underline line-through;
}
/deep/del.diffmod {
  color: red;
  text-decoration: underline line-through;
}
/deep/ins.diffmod {
  color: #00a900;
  text-decoration: underline;
}
/deep/ins.diffins {
  color: #00a900;
  text-decoration: underline;
}
/deep/.el-form-item {
  margin-bottom: 12px !important;
}
.resize-box {
  width: 100%;
  display: flex;
}

.resize-left {
  width: 75%;
  min-width: 40%;
}

.resize-right {
  width: 25%;
  min-width: 25%;
}

.resize-vertical-bar {
  position: relative;
  width: 4px;
  cursor: col-resize;
  background-size: cover;
  background-position: center;

  &:hover {
    background-color: #45a3ff;
  }
}
</style>
